/**
 * @generated SignedSource<<aa27c547ee09f4443a87064c720485ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Table_pageInfo$data = {
  readonly total: number;
  readonly " $fragmentSpreads": FragmentRefs<"TablePagination_pageInfo">;
  readonly " $fragmentType": "Table_pageInfo";
};
export type Table_pageInfo$key = {
  readonly " $data"?: Table_pageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"Table_pageInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Table_pageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TablePagination_pageInfo"
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};

(node as any).hash = "36a56577b2f69f6440fe7127ef5f955e";

export default node;
